module.exports = __webpack_public_path__ + "img/SPI AOI NG Buffer.a6e3ad02.jpg";